export default function (action, opt_label, opt_value) {
  let _hmt = window._hmt || []
  _hmt.push(['_trackEvent', action, opt_label, opt_value])
}